module.exports = __webpack_public_path__ + "static/media/palmiers.e38976ba.JPG";